import { useEffect, useState, useMemo } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { HiQuestionMarkCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import {
  useCreateKRAMutation,
  useGetAllJobTitleQuery,
  useGetAppraisalObjectivesQuery,
  useGetHrDepartmentsQuery,
  useGetJobRoleQuery,
  useGetKRATitlesQuery,
  useGetListKRAQuery,
  useGetRatingsSelectQuery,
  useGetSingleKeyResultAreaByIdQuery,
  useGetSingleKeyResultAreaQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  CheckBox,
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../../Components/Forms/InputTemplate";

import {
  appraisalPeriod,
  crossReviewType,
  currencies,
  MeasurementType,
} from "./data";
import { DEFINED_PERMISSIONS } from "../../../../../../utils/const";
import { FaMinus, FaPlus } from "react-icons/fa";

export const AutogeneratedKRAModal = ({ setIsOpen, isOpen, onValidate }) => {

  const [onCreate, { isLoading }] = useCreateKRAMutation();
  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      allKras: [{}],
    },
  });

  const {
    handleSubmit, setValue, getValues,
    formState: { isValid }, trigger,
    control,
  } = formMethods;

  const [allKras, setAllKras] = useState([{ id: Date.now() }])
  const [indexs, setIndexs] = useState(0)
  const [showIndex, setShowIndex] = useState(0)
  const handleAddKra = () => {
    const newIndex = allKras.length;
    setAllKras(prev => [...prev, { id: Date.now() }]);
    setShowIndex(prev => prev + 1);
    setIsNew(true);

    // Set default values for the new KRA
    setValue(`allKras.${newIndex}.title`, 'Select Title');
    setValue(`allKras.${newIndex}.departmentId`, '');
    setValue(`allKras.${newIndex}.objectiveId`, '');
    setValue(`allKras.${newIndex}.jobRoleId`, '');
    setValue(`allKras.${newIndex}.jobResponsibilitiesId`, '');
    setValue(`allKras.${newIndex}.periodStartDate`, '');
    setValue(`allKras.${newIndex}.appraisalPeriod`, 0);
    setValue(`allKras.${newIndex}.measurementType`, 0);
    setValue(`allKras.${newIndex}.targetValue`, '');
    setValue(`allKras.${newIndex}.currencyType`, '');
    setValue(`allKras.${newIndex}.rateId`, 0);
    setValue(`allKras.${newIndex}.threshold`, 0);
    setValue(`allKras.${newIndex}.slA_StartDuration`, 0);
    setValue(`allKras.${newIndex}.slA_ReviewDuration`, 0);
    setValue(`allKras.${newIndex}.slA_Reminder`, 0);
    setValue(`allKras.${newIndex}.weight`, 0);
    setValue(`allKras.${newIndex}.isFloatable`, false);
    setValue(`allKras.${newIndex}.is360Applicable`, false);
    setValue(`allKras.${newIndex}.includePeerReview`, false);
    setValue(`allKras.${newIndex}.peerReviewAffectsScore`, false);
    setValue(`allKras.${newIndex}.includeUpwardReview`, false);
    setValue(`allKras.${newIndex}.upwardReviewAffectsScore`, false);
    setValue(`allKras.${newIndex}.includeCrossReview`, false);
    setValue(`allKras.${newIndex}.crossReviewType`, 0);
    setValue(`allKras.${newIndex}.crossReviewAffectsScore`, false);
    setValue(`allKras.${newIndex}.description`, '');
    trigger('allKras')

  };
  const handleRemoveKra = (index) => {
    // 1. Get fresh values
    const fresh = getValues("allKras") || [];
    setIsNew(false);

    // 2. Remove item
    const updated = fresh.filter((_, i) => i !== index);

    setValue("allKras", updated, { shouldValidate: true });

    setAllKras(updated);
    setShowIndex((prev) => (prev > 0 ? prev - 1 : 0));
    setIndexs((prev) => Math.max(prev - 1, 0));
    trigger('allKras')
  };
  const watchDepartment = useWatch({ control, name: `allKras[${indexs}].departmentId` });

  const { data: departments } = useGetHrDepartmentsQuery();
  const { data: objectives } = useGetAppraisalObjectivesQuery({
    ApprovalStatus: 0,
    departmentId: watchDepartment,
    PageSize: 99999,
    PageNumber: 1,
  });
  const { data: ratings } = useGetRatingsSelectQuery({
    ApprovalStatus: 0,
  });
  const { data: jobRole } = useGetJobRoleQuery({
    ApprovalStatus: 0,
    departmentId: watchDepartment,
  });
  const { data: kraTitle } = useGetKRATitlesQuery();
  const { data: keyResultArea } = useGetListKRAQuery({
    ApprovalStatus: 0,
  });
  const is360Applicable = useWatch({ control, name: `allKras[${indexs}].is360Applicable` });
  const includePeerReview = useWatch({ control, name: `allKras[${indexs}].includePeerReview` });
  const includeUpwardReview = useWatch({
    control,
    name: `allKras[${indexs}].includeUpwardReview`,
  });
  const includeCrossReview = useWatch({ control, name: `allKras[${indexs}].includeCrossReview` });
  const watchMeasurementType = useWatch({
    control,
    name: `allKras[${indexs}].measurementType`,
  });
  const watchRateId = useWatch({ control, name: `allKras[${indexs}].rateId` });
  const id = useWatch({ control, name: `allKras[${indexs}].title` })

  const watchAttachKRACore = useWatch({ control, name: `allKras[${indexs}].noneCore` });


  const titleOptions = useMemo(() => {
    const coreOptions = kraTitle?.responseObject?.pageItems || [];
    if (watchAttachKRACore) {
      const nonCoreOptions = keyResultArea?.result || [];
      const mappedNonCoreOptions = nonCoreOptions.map((item) => ({
        ...item,
        id: `${item.id}`,
        keyResulAreaName: item.title || item.keyResulAreaName,
      }));
      return [...coreOptions, ...mappedNonCoreOptions];
    }
    return coreOptions;
  }, [kraTitle?.responseObject?.pageItems, watchAttachKRACore, keyResultArea?.result])
  const idd = (id && id !== "Select Title") ? JSON?.parse(id)?.id : ''
  const source = titleOptions?.find(dat => dat?.id === idd);
  const { data: veiwKRA } = useGetSingleKeyResultAreaQuery(id);
  const { data: keyResultAreaById } = useGetSingleKeyResultAreaByIdQuery(id);
  const populateKRA = source?.source ? keyResultAreaById : veiwKRA;
  const [isNew, setIsNew] = useState(true)
  const jobRoleId = useWatch({
    control, name: `allKras[${indexs}].jobRoleId`
  });

  // useEffect(() => {
  //   if (populateKRA?.responseObject && isNew) {
  //     const data = populateKRA.responseObject;

  //     setTimeout(() => {
  //       formMethods.setValue(`allKras[${indexs}].objectiveId`, data.objectiveId || 0);
  //       formMethods.setValue(`allKras[${indexs}].departmentId`, data?.departmentId || data?.designation?.departmentId);
  //       formMethods.setValue(`allKras[${indexs}].objectiveId`, data?.objectiveId);
  //       formMethods.setValue(`allKras[${indexs}].description`, data.description || "");
  //       formMethods.setValue(`allKras[${indexs}].isFloatable`, data.isFloatable || false);
  //       formMethods.setValue(`allKras[${indexs}].threshold`, data.threshold || 0);
  //       formMethods.setValue(`allKras[${indexs}].isAutoGenerated`, data.isAutoGenerated || false);
  //       formMethods.setValue(
  //         `allKras[${indexs}].autoGeneratedSource`,
  //         data.autoGeneratedSource || ""
  //       );
  //       formMethods.setValue(`allKras[${indexs}].targetValue`, data.targetValue || 0);
  //       formMethods.setValue(`allKras[${indexs}].measurementType`, data.measurementType || 0);
  //       formMethods.setValue(`allKras[${indexs}].jobResponsibilitiesId`, Number(data.jobResponsibilitiesId))
  //       formMethods.setValue(`allKras[${indexs}].currencyType`, data.currencyType || "");
  //       formMethods.setValue(`allKras[${indexs}].rateId`, data.rateId || 0);
  //       formMethods.setValue(`allKras[${indexs}].appraisalPeriod`, data.appraisalPeriod || 0);
  //       formMethods.setValue(`allKras[${indexs}].jobRoleId`, Number(data.jobRoleId));

  //       // Format dates for input fields
  //       if (
  //         data.periodStartDate &&
  //         data.periodStartDate !== "0001-01-01T00:00:00"
  //       ) {
  //         const startDate = new Date(data.periodStartDate)
  //           .toISOString()
  //           .split("T")[0];
  //         formMethods.setValue(`allKras[${indexs}].periodStartDate`, startDate);
  //         console.log("Set periodStartDate to:", startDate);
  //       }


  //       // Debug currency type
  //       console.log("Setting currencyType to:", data.currencyType);

  //       // SLA fields
  //       formMethods.setValue(`allKras[${indexs}].slA_StartDuration`, data.slaStartDuration || 0);
  //       formMethods.setValue(`allKras[${indexs}].slA_ReviewDuration`, data.slaReviewDuration || 0);
  //       formMethods.setValue(`allKras[${indexs}].slA_Reminder`, data.slaReminderCount || 0);
  //       formMethods.setValue(`allKras[${indexs}].weight`, data.weight || 0);

  //       // 360° Appraisal fields - Force to false by default unless explicitly true in data
  //       formMethods.setValue(`allKras[${indexs}].is360Applicable`, false);
  //       formMethods.setValue(
  //         `allKras[${indexs}].includePeerReview`,
  //         data.includePeerReview || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${indexs}].peerReviewAffectsScore`,
  //         data.peerReviewAffectsScore || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${indexs}].includeUpwardReview`,
  //         data.includeUpwardReview || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${indexs}].upwardReviewAffectsScore`,
  //         data.upwardReviewAffectsScore || false
  //       );
  //       formMethods.setValue(
  //         `allKras[${indexs}].includeCrossReview`,
  //         data.includeCrossReview || false
  //       );
  //       formMethods.setValue(`allKras[${indexs}].crossReviewType`, data.crossReviewType || 0);
  //       formMethods.setValue(
  //         `allKras[${indexs}].crossReviewAffectsScore`,
  //         data.crossReviewAffectsScore || false
  //       );
  //     }, 100); // Close setTimeout
  //   }
  //   else {
  //     // Do not reset the form to prevent clearing other KRA forms
  //   }
  // }, [populateKRA, formMethods, indexs, isNew]);



  const submit = async (datas) => {
    const payloads = []
    datas?.allKras?.filter(kra => Object.values(kra).some(
      value => Boolean(value) === true
    )).forEach(data => {
      let processedTargetValue = data.targetValue;
      if (parseInt(data.measurementType) === 5) {
        processedTargetValue = 1;
      } else if (data.targetValue !== "yesNo") {
        processedTargetValue = parseInt(data.targetValue) || 0;
      }

      const payload = {
        objectiveId: parseInt(data.objectiveId),
        title: (data?.title && data?.title !== "Select Title") ? JSON.parse(data.title)?.keyResulAreaName : '',
        description: data.description,
        isFloatable: data.isFloatable,
        threshold: parseInt(data.threshold),
        autoGeneratedSource: source?.source,
        isAutoGenerated: source?.source ? true : false,
        targetValue: processedTargetValue || '',
        measurementType: parseInt(data.measurementType),
        jobResponsibilitiesId: parseInt(data.jobResponsibilitiesId),
        currencyType: data.currencyType || "",
        rateId: parseInt(data.rateId) || 0,
        appraisalPeriod: parseInt(data.appraisalPeriod),
        periodStartDate: data.periodStartDate,
        slAStartDuration: parseInt(data.slA_StartDuration),
        slAReviewDuration: parseInt(data.slA_ReviewDuration),
        slaReminderCount: parseInt(data.slA_Reminder),
        is360Applicable: data.is360Applicable,
        includePeerReview: data.includePeerReview,
        peerReviewAffectsScore: data.peerReviewAffectsScore,
        includeUpwardReview: data.includeUpwardReview,
        upwardReviewAffectsScore: data.upwardReviewAffectsScore,
        includeCrossReview: data.includeCrossReview,
        crossReviewType: parseInt(data.crossReviewType),
        crossReviewAffectsScore: data.crossReviewAffectsScore,
        weight: parseInt(data.weight),
        jobRoleId: parseInt(data.jobRoleId),
      }
      payloads.push(payload)
    })

    try {
      const response = await onCreate({ krAs: payloads }).unwrap();
      if (response?.successful) {
        setIsOpen(false);
        onValidate();
        toast.success(response?.statusMessage, { style: { zIndex: 9999 } });
      }
    } catch (err) {
      toast.error(err?.data?.statusMessage, { style: { zIndex: 9999 } });
    }
  };
  useEffect(() => {
    if (watchMeasurementType) {
      const measurementType = MeasurementType.find(
        (type) => type.id === parseInt(watchMeasurementType)
      );
      if (measurementType?.name === "Yes/No") {
        // formMethods.setValue("targetValue", "yesNo");
        formMethods.setValue(`allKras[${indexs}].targetValue`, 1);
      } else {
        // Clear targetValue for other measurement types to allow user input
        if (measurementType?.name !== "Yes/No") {
          formMethods.setValue(`allKras[${indexs}].targetValue`, "");
        }
      }
    }
  }, [watchMeasurementType, formMethods, indexs]);

  // Update threshold when rating is selected (for Rating measurement type)
  useEffect(() => {
    if (
      parseInt(watchMeasurementType) === 4 &&
      watchRateId &&
      parseInt(watchRateId) > 0
    ) {
      // Find the selected rating
      const selectedRating = ratings?.data?.find(
        (rating) => rating.id === parseInt(watchRateId)
      );

      if (selectedRating && selectedRating.scaleLevels) {
        // Find the highest scaleNumber from the scaleLevels
        const highestScale = Math.max(
          ...selectedRating.scaleLevels.map((scale) => scale.scaleNumber)
        );

        // Set the threshold to the highest scale number
        // formMethods.setValue("threshold", highestScale);
        formMethods.setValue(`allKras[${indexs}].targetValue`, highestScale)
        console.log(
          "Setting threshold to highest scale:",
          highestScale,
          "for rating:",
          selectedRating.title
        );
      }
    }
  }, [watchMeasurementType, watchRateId, ratings, formMethods, indexs]);
  const userPerm = JSON.parse(localStorage.getItem("x-u-perm")) || [];
  const userDepartmentId = JSON.parse(localStorage.getItem("user"))?.departmentId
  const perm = [DEFINED_PERMISSIONS.SeniorHRManager,
  DEFINED_PERMISSIONS.PrimaryHRManager, DEFINED_PERMISSIONS.HRManager
  ]
  const hasAllDepartmentPermission = perm.some(user => userPerm.includes(user));


  const jobTitles = useGetAllJobTitleQuery({
    PageSize: 9999, PageNumber: 1,
    ApprovalStatus: 0, JobRoleId: jobRoleId
  })

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up</h4>
          <h1 className="text-[28px] font-[800]">key Result Area</h1>
          <p>
            Define measurable outcomes for your selected objectives by creating
            structured KRAs (Key Result Areas)
          </p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div className="flex justify-between items-center mb-6 col-span-2">
          <p className="text-black">{showIndex + 1} of {allKras?.length}</p>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              disabled={showIndex <= 0}
              className="bg-white rounded-md text-[var(--primary-color)] px-4 py-2"
              onClick={() => {
                setShowIndex(prev => Math.max(prev - 1, 0));
                setIsNew(false);
              }}
            >
              Prev
            </button>

            <button disabled={showIndex >= allKras?.length - 1}
              type="button"
              className="bg-[var(--primary-color)] text-white px-4 py-2 rounded-md"
              onClick={() => {
                setShowIndex(prev => prev + 1);
                setIsNew(false);
              }}
            >
              Next
            </button>

          </div> </div>
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              {allKras?.map((dat, index) =>
                <section onClick={() => setIndexs(index)} key={index}
                  className={`${showIndex === index ? "block" : "hidden pointer-events-none"}`}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-10" />
                    <button
                      type="button"
                      className="flex items-center gap-x-2 h-auto text-[#A0BDA2]"
                    >
                      <CheckBox
                        camelCase={`allKras[${index}].noneCore`} isRequired={false} />
                      <span>Attach non-core KRA</span>
                    </button>
                  </div>
                  <div>
                    <FormSelect
                      title={"Title"}
                      camelCase={`allKras[${index}].title`}
                      placeholder={"select"}
                      array={titleOptions?.filter(dat => dat?.source)?.map((opt) => (
                        <option key={opt.id} value={JSON.stringify(opt)}>
                          {opt?.keyResulAreaName}
                        </option>
                      ))} defaultValue={"Select Title"}
                    />
                  </div>
                  {source?.source && <FormInput readOnly={true}
                    title={"Source"}
                    camelCase={`allKras[${index}].source`} value={source?.source}
                    placeholder={"source"}
                  />}
                  <div className="grid gap-5 grid-cols-2">
                    <FormSelect
                      title={"Department"}
                      camelCase={`allKras[${index}].departmentId`}
                      placeholder={"select"}
                      array={(hasAllDepartmentPermission ? departments?.responseObject?.pageItems :
                        [departments?.responseObject?.pageItems?.find(dat => dat?.id === userDepartmentId)])?.map((opt) => (
                          <option key={opt?.id} value={opt?.id}>
                            {opt?.name}
                          </option>
                        ))}
                      defaultValue={"Select Department"}
                    />
                    <FormSelect
                      title={"Objective"}
                      camelCase={`allKras[${index}].objectiveId`}
                      placeholder={"select"}
                      array={
                        (!hasAllDepartmentPermission ?
                          objectives?.result?.filter(dat => (dat?.objectiveType?.toLowerCase() === "operational")) :
                          objectives?.result?.filter(dat => (dat?.objectiveType?.toLowerCase() === "operational") ||
                            (dat?.objectiveType?.toLowerCase() === "global")))?.map((opt) => (
                              <option key={opt.id} value={opt.id}>
                                {opt?.title} {opt?.designation?.designationName}
                              </option>
                            ))}
                      defaultValue={"Select Objective"}
                    />
                    <FormSelect
                      title={"Job Role"}
                      camelCase={`allKras[${index}].jobRoleId`}
                      placeholder={"select"}
                      array={jobRole?.responseObject?.pageItems?.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt?.designationName}
                        </option>
                      ))}
                      defaultValue={"Select Job Role"}
                    />
                    {
                      jobRoleId && <FormSelect
                        title={"Job Title"}
                        camelCase={`allKras[${index}].jobResponsibilitiesId`}
                        placeholder={"select"}
                        array={jobTitles?.data?.responseObject?.pageItems?.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {opt?.title}
                          </option>
                        ))}
                        defaultValue={"Select Job Designation"}
                      />
                    }
                    {populateKRA?.responseObject?.autoGeneratedSource && (
                      <div>
                        <label
                          htmlFor="autoGeneratedSource"
                          className="flex items-center gap-2 mb-1"
                        >
                          Source{" "}
                          <span className="text-[#AC0000] bg-[#FF8D8D] py-1 px-2 rounded-md">
                            AutoGenerated
                          </span>
                        </label>
                        <FormInput
                          title={"Source AutoGenerated"}
                          camelCase={`allKras[${index}].autoGeneratedSource`}
                          placeholder={"select"}
                          hideTitle={true}
                          disabled={true}
                        />
                      </div>
                    )}
                    <FormInput
                      title={"Period Start Date"}
                      camelCase={`allKras[${index}].periodStartDate`}
                      placeholder={"select"}
                      type={"date"}
                    />
                    <FormSelect
                      title={"Appraisal Period"}
                      camelCase={`allKras[${index}].appraisalPeriod`}
                      placeholder={"select"}
                      array={appraisalPeriod.map((opt) => (
                        <option key={opt.filter} value={opt.filter}>
                          {opt?.name}
                        </option>
                      ))}
                    />
                    <FormSelect
                      title={"Measurement Type"}
                      camelCase={`allKras[${index}].measurementType`}
                      placeholder={"select"}
                      array={MeasurementType.map((opt) => (
                        <option key={opt.id} value={opt.id}>
                          {opt.name}
                        </option>
                      ))}
                      defaultValue={0}
                    />

                    {(parseInt(watchMeasurementType) === 1 || parseInt(watchMeasurementType) === 2 || parseInt(watchMeasurementType) === 4 ||
                      parseInt(watchMeasurementType) === 3) && (
                        <FormInput
                          title={"Target Value"}
                          camelCase={`allKras[${index}].targetValue`}
                          placeholder={"Enter value"}
                          type={"number"} readOnly={parseInt(watchMeasurementType) === 4}
                          max={parseInt(watchMeasurementType) === 3 ? 100 : undefined}
                        />
                      )}

                    {parseInt(watchMeasurementType) === 2 && (
                      <FormSelect
                        title={"Currency Type"}
                        camelCase={`allKras[${index}].currencyType`}
                        placeholder={"select"}
                        array={[
                          <option key="empty" value="">
                            Select Currency
                          </option>,
                          ...currencies.map((opt) => (
                            <option key={opt.name} value={opt.name}>
                              {opt.name}
                            </option>
                          )),
                        ]}
                        defaultValue={""}
                      />
                    )}

                    {parseInt(watchMeasurementType) === 4 && (
                      <FormSelect
                        title={"Rating"}
                        camelCase={`allKras[${index}].rateId`}
                        placeholder={"select"}
                        array={[
                          <option key="empty" value={0}>
                            Select Rating
                          </option>,
                          ...(ratings?.data?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.title}
                            </option>
                          )) || []),
                        ]}
                      />
                    )}

                    {parseInt(watchMeasurementType) === 5 && (
                      <FormInput
                        title={"Yes/No Target Value"}
                        camelCase={`allKras[${index}].targetValue`}
                        placeholder={"Yes/No"}
                        type={"text"}
                        disabled={true}
                        value={1}
                        defaultValue={1}
                      />
                    )}

                    {(parseInt(watchMeasurementType) === 1 || parseInt(watchMeasurementType) === 5 ||
                      parseInt(watchMeasurementType) === 3) && (
                        <FormInput
                          title={"Threshold"}
                          camelCase={`allKras[${index}].threshold`}
                          placeholder={"Enter value"}
                          type={"number"}
                          max={parseInt(watchMeasurementType) === 3 ? 100 : undefined}
                        />
                      )}
                    {/* Show threshold for Currency (editable) */}
                    {parseInt(watchMeasurementType) === 2 && (
                      <FormInput
                        title={"Threshold"}
                        camelCase={`allKras[${index}].threshold`}
                        placeholder={"Enter threshold value"}
                        type={"number"}
                      />
                    )}

                    {/* Show threshold for Rating (auto-populated from highest scale) */}
                    {parseInt(watchMeasurementType) === 4 &&
                      watchRateId &&
                      parseInt(watchRateId) > 0 && (
                        <FormInput
                          title={"Threshold"}
                          camelCase={`allKras[${index}].threshold`}
                          placeholder={"Auto-populated from rating scale"}
                          type={"number"}
                        // disabled={true}
                        />
                      )}
                    <FormInput
                      title={"SLA Start Duration"}
                      camelCase={`allKras[${index}].slA_StartDuration`}
                      placeholder={"select"}
                      type={"number"}
                    />
                    <FormInput
                      title={"SLA Review Duration"}
                      camelCase={`allKras[${index}].slA_ReviewDuration`}
                      placeholder={"select"}
                      type={"number"}
                    />
                    <FormInput
                      title={"SLA Reminder"}
                      camelCase={`allKras[${index}].slA_Reminder`}
                      placeholder={"select"}
                      type={"number"}
                    />

                    <FormInput
                      title={"Weight"}
                      camelCase={`allKras[${index}].weight`}
                      placeholder={"select"}
                      type={"number"}
                    />
                  </div>

                  {/* Basic Options */}
                  <div className="grid gap-3 grid-cols-3 mb-4">
                    <div className="flex items-center gap-2">
                      <CheckBox isRequired={false} camelCase={`allKras[${index}].isFloatable`} />
                      <small>Is Floatable</small>
                    </div>
                  </div>

                  {/* 360° Appraisal Section */}
                  <div className="mb-4">
                    <div className="flex items-center gap-2 mb-3">
                      <CheckBox isRequired={false} camelCase={`allKras[${index}].is360Applicable`} />
                      <small className="font-semibold">Apply 360° Appraisal?</small>
                      <HiQuestionMarkCircle
                        className="text-gray-500 cursor-help"
                        size={16}
                        title="Enable comprehensive feedback from multiple perspectives including peers, subordinates, and cross-functional teams"
                      />
                    </div>

                    {/* Conditional 360° Appraisal Options */}
                    {is360Applicable && (
                      <div className="ml-6 border-l-2 border-gray-200 pl-4 space-y-3">
                        {/* Peer Review Section */}
                        <div className="space-y-2">
                          <div className="flex items-center gap-2">
                            <CheckBox camelCase={`allKras[${index}].includePeerReview`} />
                            <small>Peer Review</small>
                            <HiQuestionMarkCircle
                              className="text-gray-500 cursor-help"
                              size={14}
                              title="Feedback from colleagues at the same level"
                            />
                          </div>
                          {includePeerReview && (
                            <div className="ml-6">
                              <div className="flex items-center gap-2">
                                <CheckBox camelCase={`allKras[${index}].peerReviewAffectsScore`} />
                                <small>Affects Overall Score?</small>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Upward Review Section */}
                        <div className="space-y-2">
                          <div className="flex items-center gap-2">
                            <CheckBox camelCase={`allKras[${index}].includeUpwardReview`} />
                            <small>Upward Review</small>
                            <HiQuestionMarkCircle
                              className="text-gray-500 cursor-help"
                              size={14}
                              title="Feedback from subordinates – commonly for leadership KRAs"
                            />
                          </div>
                          {includeUpwardReview && (
                            <div className="ml-6">
                              <div className="flex items-center gap-2">
                                <CheckBox camelCase={`allKras[${index}].upwardReviewAffectsScore`} />
                                <small>Affects Overall Score?</small>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Cross Review Section */}
                        <div className="space-y-2">
                          <div className="flex items-center gap-2">
                            <CheckBox camelCase={`allKras[${index}].includeCrossReview`} />
                            <small>Cross Review</small>
                            <HiQuestionMarkCircle
                              className="text-gray-500 cursor-help"
                              size={14}
                              title="Review from other units or departments"
                            />
                          </div>
                          {includeCrossReview && (
                            <div className="ml-6 space-y-2">
                              <div className="grid gap-3 grid-cols-1">
                                <FormSelect
                                  title={"Specify Type"}
                                  camelCase={`allKras[${index}].crossReviewType`}
                                  placeholder={"select"}
                                  array={crossReviewType.map((opt) => (
                                    <option key={opt.id} value={opt.id}>
                                      {opt.name}
                                    </option>
                                  ))}
                                  isOptional={true}
                                />
                              </div>
                              <div className="flex items-center gap-2">
                                <CheckBox camelCase={`allKras[${index}].crossReviewAffectsScore`} />
                                <small>Affects Overall Score?</small>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <FormTextArea
                    className="h-[200px]"
                    title={"Description"}
                    camelCase={`allKras[${index}].description`}
                  />

                  <div className="flex justify-end gap-4 mt-6">
                    {allKras?.length > 1 &&
                      <button onClick={() => handleRemoveKra(index)}
                        type="button"
                        className=" bg-red-50 text-red-900
                                 px-5 py-2 rounded-sm flex items-center space-x-2"
                      >
                        <FaMinus />

                        <span>Remove  KRA</span>
                      </button>
                    }
                    <button onClick={handleAddKra}
                      type="button"
                      className="bg-[#18BB0C1A] text-[#18BB0C]
                                px-5 py-2 rounded-sm flex items-center space-x-2"
                    >
                      <FaPlus />

                      <span>Add  KRA</span>
                    </button>
                  </div>


                </section>)}
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  {isLoading ? "Creating..." : "Create"}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};
